import { render, staticRenderFns } from "./genre.vue?vue&type=template&id=30814431&"
import script from "./genre.vue?vue&type=script&lang=js&"
export * from "./genre.vue?vue&type=script&lang=js&"
import style0 from "./genre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports